import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { getShiftPath, type GetShiftResponse } from "@src/appV2/Shifts/Shift/api/useGetShift";
import { type QueryClient } from "@tanstack/react-query";

import { TIMEKEEPING_NETWORK_RETRY_MAX_ATTEMPTS } from "../constants";

interface LogTimekeepingNetworkRetryAttemptParams {
  queryClient: QueryClient;
  shiftId: string | undefined;
  source: string;
  attempt: number;
  action: string | undefined;
}

export function logTimekeepingNetworkRetryAttempt(
  params: LogTimekeepingNetworkRetryAttemptParams
): void {
  const { queryClient, shiftId, source, attempt, action } = params;

  const cachedShift = shiftId
    ? queryClient.getQueryData<GetShiftResponse>([
        `${environmentConfig.REACT_APP_BASE_API_URL}${getShiftPath(shiftId)}`,
        undefined,
      ])
    : undefined;

  const eventPayload = {
    source,
    attempt,
    maxAttempts: TIMEKEEPING_NETWORK_RETRY_MAX_ATTEMPTS,
    shiftId,
    action,
    workplaceId: cachedShift?.response.facilityId,
    workerId: cachedShift?.response.agentId,
  };

  logEvent(APP_V2_USER_EVENTS.TIMEKEEPING_NETWORK_RETRY_ATTEMPT, eventPayload);

  if (attempt === TIMEKEEPING_NETWORK_RETRY_MAX_ATTEMPTS) {
    logEvent(APP_V2_USER_EVENTS.TIMEKEEPING_NETWORK_RETRY_EXHAUSTED, eventPayload);
  }
}
